import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";
import stockTransferService from "../services/stockTransferService";
import StorageService from "../services/StorageService";
import Loading from "../components/loading";
import usePermission from "../utils/UsePermission";
import ScreenData from "../config/ScreenData";
import UnAuthorized from "../views/Unathorized";
import ReactPaginate from "react-paginate";
import MessageDialog from "../components/MessageDialog";
import utility from "../utils/utility";
import CompanyService from "../services/companyService";
import ProjectService from "../services/ProjectService";


export default function ViewStockTransferMain() {
  const companyId = StorageService.activeCompany()?.companyId;
  const employeeId = StorageService.loginData()?.employeeId;
  const roleId = StorageService.loginData()?.roleId;

  const [transfers, setTransfers] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("error");
  const [selectedId, setSelectedId] = useState(null);
  const navigate = useNavigate();

  const [showPopup, setShowPopup] = useState(false);
  const [popupLoading, setPopupLoading] = useState(false);
  const [popupHeader, setPopupHeader] = useState(null);
  const [popupDetails, setPopupDetails] = useState([]);
  const [projectList, setProjectList] = useState([]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const pRes = await ProjectService.getActive(companyId);
        const pData = pRes?.data || pRes || [];
        setProjectList(Array.isArray(pData) ? pData : []);
      } catch (e) {
        console.error("Failed to load projects:", e);
      }
    };
    if (companyId) {
      fetchProjects();
    }
  }, [companyId]);

  const loadPopupDetails = async (id) => {
    try {
      setPopupLoading(true);
      const res = await stockTransferService.getById(id);
      const data = res?.data?.data || res?.data || res;
      setPopupHeader(data);
      setPopupDetails(data?.stockTransferDetails || []);
    } catch (err) {
      console.error("Popup detail load failed", err);
      showMessage("Failed to load transfer details");
      setPopupHeader(null);
      setPopupDetails([]);
    } finally {
      setPopupLoading(false);
    }
  };
  // const messageTimer = useRef(null);

  const selectedTransfer = transfers.find(t => t.id === selectedId);
  const isInTransit = selectedTransfer?.status === "intransit";

  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [allTransfers, setAllTransfers] = useState([]);
  const [statusFilter, setStatusFilter] = useState("all");
  const [companies, setCompanies] = useState([]);
  const [companyFilter, setCompanyFilter] = useState("ALL");
  const [searchText, setSearchText] = useState("");
  const [search, setSearch] = useState("");
  const itemsPerPage = 10;

  // Utility: Show message
  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  const { permission, can } = usePermission(
    ScreenData.Stock_Transfer,
    showMessage
  );

  // Handle Add
  const handleAdd = () => {
    navigate("/cpnl/StockTransfer/add");
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    return utility.formatDateDDMMMYYYY(dateStr);
  };

  const formatEmployee = (name, code) => {
    if (name && code) return `${name} (${code})`;
    return name || code || "-";
  };

  const formatProject = (name, code, categoryName) => {
    const matchedProject =
      (name && projectList.find((p) => p.projectName === name)) || {};
    const catName = categoryName || matchedProject.projectCategoryName || matchedProject.categoryName || "";
    const projCode = code || matchedProject.projectCode || "";
    const categoryInitial = String(catName || "").trim().charAt(0).toUpperCase();

    if (name) {
      if (categoryInitial) return `${categoryInitial}*${name}`;
      if (projCode) {
        const codeInitial = String(projCode).trim().charAt(0).toUpperCase();
        return `${codeInitial}*${name}`;
      }
      return name;
    }
    return "-";
  };

  const formatQty = (val) => {
    if (val === null || val === undefined || val === "") return "-";
    const num = Number(val);
    return isNaN(num) ? "-" : num.toFixed(3);
  };

  const handleModify = () => {

    if (!selectedId)
      return showMessage("Please select one transfer to modify.");

    const transfer = transfers.find(t => t.id === selectedId);

    if (!transfer)
      return showMessage("Invalid selection");

    if (transfer.status !== "intransit")
      return showMessage("Only InTransit transfers can be modified");

    navigate(`/cpnl/StockTransfer/add/${selectedId}`);

  };


  // useEffect(() => {
  //   const loadTransfers = async () => {
  //     try {
  //       setLoading(true);

  //       const companyId = StorageService.activeCompany().companyId;
  //       const employeeId = StorageService.loginData().employeeId;


  //       const res = await stockTransferService.getAll(companyId);
  //       const data = res?.data || [];

  //       setTransfers(
  //         data.sort((a, b) => b.id - a.id) // DESC by id
  //       );

  //      setSelectedId(null);
  //     } catch (err) {
  //       console.error(err);
  //       showMessage("Failed to load stock transfers");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   loadTransfers();
  // }, []);



  useEffect(() => {

    const delayDebounce = setTimeout(() => {

      setCurrentPage(1);
      setSearch(searchText);

    }, 400);

    return () => clearTimeout(delayDebounce);

  }, [searchText]);

  useEffect(() => {
    setCurrentPage(1);
  }, [statusFilter, companyFilter]);

  useEffect(() => {
    const loadCompanies = async () => {
      try {
        const res = await CompanyService.getActiveCompanies();
        setCompanies(res?.data || res || []);
      } catch (err) {
        console.error("Failed to load companies", err);
      }
    };
    loadCompanies();
  }, []);


  useEffect(() => {

    if (permission === null) return;

    if (permission.canView !== 1) {
      setLoading(false);
      return;
    }
    const loadTransfers = async () => {
      try {
        setLoading(true);


        console.log("CompanyId:", companyId);
        console.log("EmployeeId:", employeeId);

        const res = await stockTransferService.getAll(
          companyId,
          employeeId,
          roleId,
          1,
          1000,
          search,
          statusFilter,
          companyFilter
        );

        const rows = Array.isArray(res?.data) ? res?.data : [];

        const sortedRows = [...rows].sort((a, b) => b.id - a.id);
        setAllTransfers(sortedRows);
        const totalPages = Math.max(1, Math.ceil(sortedRows.length / itemsPerPage));
        setPageCount(totalPages);
        const safePage = Math.min(currentPage, totalPages);
        if (safePage !== currentPage) {
          setCurrentPage(safePage);
        }
        const start = (safePage - 1) * itemsPerPage;
        const end = start + itemsPerPage;
        setTransfers(sortedRows.slice(start, end));
        setSelectedId(null);
      } catch (err) {
        console.error(err);
        showMessage("Failed to load stock transfers");
      } finally {
        setLoading(false);
      }
    };

    loadTransfers();
  }, [companyId, employeeId, roleId, currentPage, permission, search, statusFilter, companyFilter]);

  useEffect(() => {
    const start = (currentPage - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    setTransfers(allTransfers.slice(start, end));
  }, [allTransfers, currentPage]);




  // Handle Modify
  // const handleModify = () => {
  //   if (selected.length === 0)
  //     return showMessage("Please select one stockTransfer to modify.");
  //   if (selected.length > 1)
  //     return showMessage("Please select only one stockTransfer to modify.");

  //   const editItem = transfers.find((r) => r.id === selected[0]);
  //   localStorage.setItem("editStockIndent", JSON.stringify(editItem));
  //   navigate("/cpnl/StockTransfer/add");
  // };

  // Handle Delete
  // const handleDelete = () => {
  //   if (selected.length === 0)
  //     return showMessage("Please select at least one stockTransfer to delete.");

  //   const updated = transfers.filter((r) => !selected.includes(r.id));
  //   setTransfers(updated);
  //   localStorage.setItem("stockTransferMain", JSON.stringify(updated));
  //   setSelected([]);
  //   showMessage("Selected stockTransfer deleted successfully.", "success");
  // };

  // Handle View Details
  const handleView = async () => {
    if (!selectedId)
      return showMessage("Please select one stockTransfer to view details.");

    setShowPopup(true);
    await loadPopupDetails(selectedId);
  };

  const handleCancel = async () => {

    if (!selectedId)
      return showMessage("Please select one transfer to cancel.");

    const transfer = transfers.find(t => t.id === selectedId);

    if (!transfer || transfer.status !== "intransit")
      return showMessage("Only InTransit transfers can be cancelled");

    //  ALERT
    const confirm = window.confirm("Are you sure you want to cancel this transfer?");

    if (!confirm) return;

    try {
      const employeeId = StorageService.loginData().employeeId;

      await stockTransferService.cancelTransfer(selectedId, { employeeId });

      showMessage("Stock Transfer cancelled successfully", "success");

      setTimeout(() => window.location.reload(), 800);

    } catch (err) {
      showMessage(err.response?.data?.message || "Cancel failed");
    }
  };

  if (permission === null) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  if (!permission || permission.canView !== 1) {
    return <UnAuthorized />;
  }

  return (
    <>
      <Breadcrumb
        pageTitle="Stock Transfer"
        secondTitle="Inventory"
      ></Breadcrumb>
      <div className="card p-3 bg-white shadow-sm">
        {/* Message Box */}
        {/* {message && (
          <div
            className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
              } d-flex justify-content-between align-items-center w-100 mb-2 p-2`}
            style={{ borderRadius: "5px" }}
          >
            <span>{message}</span>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={closeMessage}
              style={{ fontSize: "0.8rem" }}
            ></button>
          </div>
        )} */}


        <MessageDialog
          message={message}
          type={msgType}
          setMessage={setMessage}
          setMsgType={setMsgType}
        />


        <div className="mb-3 pb-2 border-bottom d-flex align-items-center flex-wrap gap-2">

          {can("canAdd") && (
            <button
              className="d-inline-flex btn btn-success me-2"
              onClick={handleAdd}
              disabled={loading}
            >
              <i class="ti ti-plus me-1"></i> Add
            </button>
          )}


          {can("canModify") && (
            <button
              className="d-inline-flex btn btn-warning me-2"
              onClick={handleModify}
              disabled={!isInTransit}

            >
              <i className="ti ti-pencil me-1"></i> Modify
            </button>
          )}

          {can("canView") && (
            <>
              <button
                className="d-inline-flex btn btn-primary me-2"
                onClick={handleView}
              >
                <i class="ti ti-eye me-1"></i> View
              </button>


              {can("canCancel") && (
                <button
                  className="d-inline-flex btn btn-dark me-2"
                  onClick={handleCancel}
                  disabled={!isInTransit}
                >
                  <i class="ti ti-x me-1"></i> Cancel
                </button>
              )}



              <select
                className="form-select d-inline w-auto"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="all">All</option>
                <option value="intransit">InTransit</option>
                <option value="received">Received</option>
                <option value="cancelled">Cancelled</option>
              </select>

              <select
                className="form-select d-inline w-auto ms-2"
                value={companyFilter}
                onChange={(e) => setCompanyFilter(e.target.value)}
              >
                <option value="ALL">All To Companies</option>
                {companies.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.companyName}
                  </option>
                ))}
              </select>

              <div className="d-flex align-items-center ms-auto">
                <div className="position-relative">

                  <input
                    type="text"
                    className="form-control pe-5"
                    placeholder="Search Voucher/Project/Vehicle"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    style={{ width: "280px" }}
                  />

                  <i
                    className="ti ti-search position-absolute"
                    style={{
                      right: "15px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#6c757d"
                    }}
                  ></i>

                </div>
              </div>
            </>
          )}


        </div>

        {/* Table */}
        <div className="table-responsive">
          <table className="table table-striped table-bordered mb-0">
            <thead className="table-light">
              <tr>
                <th>Select</th>
                {/* <th>From Company</th> */}
                <th>Voucher No</th>
                <th>Transfer Date</th>
                <th>To Company</th>
                <th>From Project</th>
                <th>To Project</th>
                <th>From Store</th>
                <th>To Store</th>
                <th>Status</th>
                {/* <th>Status</th> */}
                {/* <th>Created By</th>
                  <th>Created Date</th> */}
                {/* <th>Updated By</th>
                  <th>Updated Date</th> */}
                {/* <th>Actions</th> */}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" className="text-center py-4">
                    <Loading />
                  </td>
                </tr>
              ) : transfers.length > 0 ? (
                transfers.map((t) => (
                  <tr key={t.id}>
                    <td>
                      <input
                        type="radio"
                        name="stockTransferSelect"
                        checked={selectedId === t.id}
                        onChange={() => setSelectedId(t.id)}
                      />
                    </td>
                    <td>{t.vocherNo}</td>
                    <td>{formatDate(t.transferDate)}</td>
                    <td>{t.toCompanyName}</td>
                    <td>{formatProject(t.fromProjectName, t.fromProjectCode, t.fromProjectCategoryName)}</td>
                    <td>{formatProject(t.toProjectName, t.toProjectCode, t.toProjectCategoryName)}</td>
                    <td>{t.fromStoreName}</td>
                    <td>{t.toStoreName}</td>


                    <td>

                      <span className={`badge ${t.status === "intransit" ? "bg-warning" :
                        t.status === "received" ? "bg-success" :
                          t.status === "cancelled" ? "bg-dark" :
                            "bg-danger"
                        }`}>
                        {t.status}
                      </span>

                    </td>

                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="22" className="text-center text-muted">
                    No Stock Transfers found
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <ReactPaginate
            forcePage={Math.max(0, Math.min(currentPage - 1, Math.max(pageCount - 1, 0)))}
            onPageChange={(e) => setCurrentPage(e.selected + 1)}
            pageCount={Math.max(1, pageCount)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            previousLabel="< Previous"
            nextLabel="Next >"
            containerClassName="pagination-container"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            nextClassName="page-item"
            activeClassName="active"
          />
        </div>
      </div>

      {showPopup && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Transfer Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowPopup(false)}
                />
              </div>

              <div className="modal-body">
                {popupLoading ? (
                  <div className="text-center p-4">
                    <Loading />
                  </div>
                ) : (
                  <>
                    <div className="row mb-3">
                      {/* 1. Transfer Date & 2. Voucher No (Bold) */}
                      <div className="col-md-6">
                        <strong>Transfer Date:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{formatDate(popupHeader?.transferDate || selectedTransfer?.transferDate)}</span>
                      </div>
                      <div className="col-md-6">
                        <strong>Voucher No:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{popupHeader?.vocherNo || selectedTransfer?.vocherNo || "-"}</span>
                      </div>

                      {/* 3. From Company & 4. To Company */}
                      <div className="col-md-6 mt-2">
                        <strong>From Company:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{popupHeader?.fromCompanyName || selectedTransfer?.fromCompanyName || "-"}</span>
                      </div>
                      <div className="col-md-6 mt-2">
                        <strong>To Company:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{popupHeader?.toCompanyName || selectedTransfer?.toCompanyName || "-"}</span>
                      </div>

                      {/* Remaining fields */}
                      <div className="col-md-6 mt-2">
                        <strong>From Project:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{popupHeader ? formatProject(popupHeader.fromProjectName, popupHeader.fromProjectCode, popupHeader.fromProjectCategoryName) : selectedTransfer ? formatProject(selectedTransfer.fromProjectName, selectedTransfer.fromProjectCode, selectedTransfer.fromProjectCategoryName) : "-"}</span>
                      </div>
                      <div className="col-md-6 mt-2">
                        <strong>To Project:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{popupHeader ? formatProject(popupHeader.toProjectName, popupHeader.toProjectCode, popupHeader.toProjectCategoryName) : selectedTransfer ? formatProject(selectedTransfer.toProjectName, selectedTransfer.toProjectCode, selectedTransfer.toProjectCategoryName) : "-"}</span>
                      </div>

                      <div className="col-md-6 mt-2">
                        <strong>From Store:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{popupHeader?.fromStoreName || selectedTransfer?.fromStoreName || "-"}</span>
                      </div>
                      <div className="col-md-6 mt-2">
                        <strong>To Store:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{popupHeader?.toStoreName || selectedTransfer?.toStoreName || "-"}</span>
                      </div>

                      <div className="col-md-6 mt-2">
                        <strong>Status:</strong>{" "}
                        <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>
                          {(popupHeader?.status || selectedTransfer?.status || "-").toUpperCase()}
                        </span>
                      </div>
                      <div className="col-md-6 mt-2">
                        <strong>Remarks / Transfer Note:</strong> {popupHeader?.stockTransferNote || selectedTransfer?.stockTransferNote || "-"}
                      </div>

                      <div className="col-md-6 mt-2">
                        <strong>Created By:</strong> {formatEmployee(popupHeader?.createdByName, popupHeader?.createdByCode)}
                      </div>

                      {/* Conditional Action Notes */}
                      {(popupHeader?.status || selectedTransfer?.status)?.toLowerCase() === "received" && (
                        <>
                          <div className="col-md-6 mt-2">
                            <strong>Received / Approved By:</strong> {formatEmployee(popupHeader?.receivedByName, popupHeader?.receivedByCode)}
                          </div>
                          <div className="col-md-6 mt-2">
                            <strong>Received Notes:</strong> {popupHeader?.receivedNotes || popupHeader?.approvedNotes || "-"}
                          </div>
                        </>
                      )}

                      {(popupHeader?.status || selectedTransfer?.status)?.toLowerCase() === "rejected" && (
                        <>
                          <div className="col-md-6 mt-2">
                            <strong>Rejected By:</strong> {formatEmployee(popupHeader?.rejectedByName, popupHeader?.rejectedByCode)}
                          </div>
                          <div className="col-md-6 mt-2">
                            <strong>Rejection Notes:</strong> {popupHeader?.rejectedNotes || "-"}
                          </div>
                        </>
                      )}

                      {(popupHeader?.status || selectedTransfer?.status)?.toLowerCase() === "cancelled" && (
                        <>
                          <div className="col-md-6 mt-2">
                            <strong>Cancelled By:</strong> {formatEmployee(popupHeader?.cancelledByName, popupHeader?.cancelledByCode)}
                          </div>
                          <div className="col-md-6 mt-2">
                            <strong>Cancelled Notes:</strong> {popupHeader?.cancelledNotes || "-"}
                          </div>
                        </>
                      )}
                    </div>

                    <div className="table-responsive" style={{ maxHeight: "150px", overflowY: "auto" }}>
                      <table className="table table-bordered table-striped mb-0">
                        <thead className="table-light sticky-top" style={{ zIndex: 2 }}>
                          <tr>
                            <th>Item Category</th>
                            <th>Item</th>
                            <th>UOM</th>
                            <th>Transfer Qty</th>
                            <th>Received Qty</th>
                            <th>Damaged Qty</th>
                            <th>Scrap Store</th>
                            <th>Missed Qty</th>
                          </tr>
                        </thead>
                        <tbody>
                          {popupDetails.length > 0 ? (
                            popupDetails.map((row, idx) => (
                              <tr key={idx}>
                                <td>{row.itemCategoryName || "-"}</td>
                                <td>{row.itemCode || row.itemName || row.itemDescription || "-"}</td>
                                <td>{row.UOM || row.uom || "-"}</td>
                                <td>{formatQty(row.quantity ?? row.transferQuantity)}</td>
                                <td>{formatQty(row.receivedQuantity)}</td>
                                <td>{formatQty(row.damagedQuantity)}</td>
                                <td>
                                  {parseFloat(row.damagedQuantity || 0) > 0 && row.scrapStoreName
                                    ? `${row.scrapStoreName}${row.scrapStoreCode ? ` (${row.scrapStoreCode})` : ""}`
                                    : "-"}
                                </td>
                                <td>{formatQty(row.lostQuantity)}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="8" className="text-center text-muted">
                                No items found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-success me-2"
                  onClick={() => {
                    setShowPopup(false);
                    navigate(`/cpnl/StockTransfer/view/${selectedId}`);
                  }}
                >
                  <i className="ti ti-printer me-1"></i>
                  Go to Print / Details Page
                </button>

                <button
                  className="btn btn-secondary"
                  onClick={() => setShowPopup(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}